(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-calendar"] && !Shopify.designMode) return;
  try {
    
  // Sort and filter functionality
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('events-container-sortable');
    const filters = document.querySelectorAll('.events-filter');
    
    if (!container) return;
    
    // Sort events by date (chronologically - soonest first)
    function sortEvents() {
      const eventListings = Array.from(container.querySelectorAll('.event-listing'));
      
      eventListings.sort(function(a, b) {
        const dateA = a.getAttribute('data-event-date');
        const dateB = b.getAttribute('data-event-date');
        
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1; // Events without dates go to the end
        if (!dateB) return -1;
        
        // Compare dates (YYYY-MM-DD format allows string comparison)
        return dateA.localeCompare(dateB);
      });
      
      // Re-append sorted events to container
      eventListings.forEach(event => {
        container.appendChild(event);
      });
    }
    
    // Sort events on page load
    sortEvents();
    
    // Format times to 12-hour format
    function formatTimeTo12Hour(timeString) {
      if (!timeString) return timeString;
      
      // Handle time ranges (e.g., "17:00 - 21:00" or "5:00 PM - 9:00 PM")
      if (timeString.includes(' - ')) {
        const parts = timeString.split(' - ');
        return parts.map(part => formatSingleTime(part.trim())).join(' - ');
      }
      
      return formatSingleTime(timeString);
    }
    
    function formatSingleTime(timeStr) {
      // If already in 12-hour format with AM/PM, return as is
      if (timeStr.match(/\d{1,2}:\d{2}\s*(AM|PM)/i)) {
        return timeStr;
      }
      
      // Try to parse 24-hour format (HH:MM or HH:MM:SS)
      const time24Match = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      if (time24Match) {
        let hours = parseInt(time24Match[1], 10);
        const minutes = time24Match[2];
        const period = hours >= 12 ? 'PM' : 'AM';
        
        if (hours === 0) {
          hours = 12;
        } else if (hours > 12) {
          hours = hours - 12;
        }
        
        return `${hours}:${minutes} ${period}`;
      }
      
      // If no match, return original
      return timeStr;
    }
    
    // Apply 12-hour formatting to all time displays
    document.querySelectorAll('.event-time-display').forEach(function(timeElement) {
      const startTime = timeElement.getAttribute('data-start-time');
      const endTime = timeElement.getAttribute('data-end-time');
      const originalTime = timeElement.getAttribute('data-time');
      
      if (startTime && endTime) {
        // Format start and end times separately
        const formattedStart = formatSingleTime(startTime);
        const formattedEnd = formatSingleTime(endTime);
        timeElement.textContent = formattedStart + ' - ' + formattedEnd;
      } else if (originalTime) {
        // Fallback to single time field
        const formattedTime = formatTimeTo12Hour(originalTime);
        timeElement.textContent = formattedTime;
      }
    });
    
    // Filter events by month
    function filterByMonth(filterValue) {
      const eventListings = container.querySelectorAll('.event-listing');
      
      eventListings.forEach(event => {
        const eventMonth = event.getAttribute('data-month');
        
        // Show event if its month matches the filter (case-insensitive)
        if (eventMonth && eventMonth.toLowerCase() === filterValue.toLowerCase()) {
          event.style.display = '';
        } else {
          event.style.display = 'none';
        }
      });
    }
    
    // Apply initial filter for first active month
    if (window.firstActiveMonth) {
      filterByMonth(window.firstActiveMonth);
    }
    
    // Filter functionality
    filters.forEach(filter => {
      filter.addEventListener('click', function() {
        // Remove active class from all filters
        filters.forEach(f => f.classList.remove('events-filter--active'));
        // Add active class to clicked filter
        this.classList.add('events-filter--active');

        const filterValue = this.getAttribute('data-filter');
        filterByMonth(filterValue);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-event"] && !Shopify.designMode) return;
  try {
    
  // Format times to 12-hour format
  function formatSingleTime(timeStr) {
    if (!timeStr) return timeStr;
    
    // If already in 12-hour format with AM/PM, return as is
    if (timeStr.match(/\d{1,2}:\d{2}\s*(AM|PM)/i)) {
      return timeStr;
    }
    
    // Try to parse 24-hour format (HH:MM or HH:MM:SS)
    const time24Match = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (time24Match) {
      let hours = parseInt(time24Match[1], 10);
      const minutes = time24Match[2];
      const period = hours >= 12 ? 'PM' : 'AM';
      
      if (hours === 0) {
        hours = 12;
      } else if (hours > 12) {
        hours = hours - 12;
      }
      
      return `${hours}:${minutes} ${period}`;
    }
    
    // If no match, return original
    return timeStr;
  }
  
  // Apply 12-hour formatting to all time displays
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.event-time-display').forEach(function(timeElement) {
      const startTime = timeElement.getAttribute('data-start-time');
      const endTime = timeElement.getAttribute('data-end-time');
      const originalTime = timeElement.getAttribute('data-time');
      
      if (startTime && endTime) {
        // Format start and end times separately
        const formattedStart = formatSingleTime(startTime);
        const formattedEnd = formatSingleTime(endTime);
        timeElement.textContent = formattedStart + ' - ' + formattedEnd;
      } else if (originalTime) {
        // Handle time ranges in single field
        if (originalTime.includes(' - ')) {
          const parts = originalTime.split(' - ');
          const formattedParts = parts.map(part => formatSingleTime(part.trim()));
          timeElement.textContent = formattedParts.join(' - ');
        } else {
          // Single time
          timeElement.textContent = formatSingleTime(originalTime);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
